import { render, staticRenderFns } from "./DeviceNotSupportedForRtc.vue?vue&type=template&id=2e97d883&scoped=true&"
import script from "./DeviceNotSupportedForRtc.vue?vue&type=script&lang=js&"
export * from "./DeviceNotSupportedForRtc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e97d883",
  null
  
)

export default component.exports